<template>
    <v-card flat style="overflow: hidden">
        <v-responsive :aspect-ratio="4 / 3" content-class="grey lighten-5" ref="container">
            <video ref="video" :src-object.prop.camel="stream_canvas" autoplay playsinline class="mb-n8" />
        </v-responsive>
        <v-overlay absolute v-if="stream_media">
            <canvas ref="canvas" v-bind="{ width, height }" class="mb-n8" />
        </v-overlay>
    </v-card>
</template>

<script>
import { mapGetters, mapMutations, mapState } from "vuex";

export default {
    data: () => ({
        width: undefined,
        height: undefined,
    }),
    computed: {
        ...mapState("interview/client", ["stream_media"]),
        ...mapGetters("interview/client", ["stream_canvas"]),
    },
    methods: {
        ...mapMutations("interview/client", ["setStream"]),
        init() {
            if (!!this.stream_media) {
                this.$nextTick(() => {
                    let video = this.$refs["video"];
                    let canvas = this.$refs["canvas"];
                    let context = canvas.getContext("2d");
                    const drawImage = () => {
                        const container = this.$refs["container"]?.$el;
                        const { width, height } = container?.getClientRects?.()?.[0] || {};
                        if (width && height) {
                            this.width = width;
                            this.height = height;
                            context.drawImage(video, 0, 0, this.width, this.height);
                        }
                        setTimeout(drawImage, 1);
                    };

                    setTimeout(drawImage, 1);

                    let intervalId = setInterval(() => {
                        /** @type {MediaStream} */
                        const canvasStream = canvas.captureStream();

                        let stream = new MediaStream();
                        let audio = this.stream_media?.getAudioTracks?.()?.[0];
                        if (!audio) return;
                        let video = canvasStream?.getVideoTracks?.()?.[0];
                        if (!video) return;
                        stream.addTrack(audio);
                        stream.addTrack(video);
                        this.setStream({ stream });
                        clearInterval(intervalId);
                    }, 100);
                });
            }
        },
    },
    watch: {
        stream_media() {
            this.init();
        },
    },
    mounted() {
        this.init();
    },
};
</script>

<style>
</style>